import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axios';

export const useUsers = (role) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!role) return;

    const fetchUsers = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axiosInstance.get(`/user/all/${role}`);
        setUsers(response.data.users || []);
      } catch (err) {
        setError(err.message || 'Failed to fetch users');
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [role]);

  return { users, loading, error };
};
